import { Box, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import { AiFillGithub } from "react-icons/ai";
import {
  DiCss3Full,
  DiGit,
  DiHtml5,
  DiJavascript1,
  DiReact,
} from "react-icons/di";
import {
  SiChakraui,
  SiCypress,
  SiJest,
  SiNetlify,
  SiNpm,
  SiRedux,
  SiTypescript,
  SiVisualstudiocode,
} from "react-icons/si";
import { TbBrandNextjs } from "react-icons/tb";
import GitHubCalender from "react-github-calendar";
import "./all.css";
const skills = [
  {
    icon: <DiJavascript1 />,
    label: "JavaScript",
  },
  {
    icon: <DiHtml5 />,
    label: "HTML",
  },
  {
    icon: <DiCss3Full />,
    label: "CSS",
  },
  {
    icon: <DiReact />,
    label: "ReactJS",
  },
  {
    icon: <SiChakraui />,
    label: "Chakra UI",
  },
  {
    icon: <SiTypescript />,
    label: "TypeScript",
  },
  {
    icon: <TbBrandNextjs />,
    label: "NextJS",
  },
  {
    icon: <SiRedux />,
    label: "Redux",
  },
];
const tools = [
  {
    icon: <AiFillGithub />,
    label: "Git Hub",
  },
  {
    icon: <SiVisualstudiocode />,
    label: "VS Code",
  },
  {
    icon: <SiNetlify />,
    label: "Netlify",
  },
  {
    icon: <SiNpm />,
    label: "NPM",
  },
  {
    icon: <SiCypress />,
    label: "Cypress",
  },
  {
    icon: <DiGit />,
    label: "Git",
  },
  {
    icon: <SiJest />,
    label: "Jest",
  },
];
const Skills = () => {
  return (
    <Box id="skills">
      <Box h="100px"></Box>
      <Heading
        w={{ base: "70%", "2xl": "15%" }}
        p="10px"
        m="auto"
        borderBottom={"5px solid white"}
      >
        Skills
      </Heading>
      <Box
        display={"grid"}
        gridTemplateColumns={{
          base: "repeat(1,1fr)",
          sm: "repeat(1,1fr)",
          lg: "repeat(2,1fr)",
          xl: "repeat(4,1fr)",
        }}
        gap="40px"
        justifyContent="space-between"
        w="80%"
        m="auto"
        mt="100px"
      >
        {skills.map((i) => {
          return (
            <Box
              key={i.label}
              className="skills-card"
              cursor={"pointer"}
              boxShadow="rgba(89, 4, 168, 0.137) 4px 5px 4px 3px !important"
              p="20px"
              border={"1.7px solid rgba(200, 137, 230, 0.635)"}
              borderRadius="6px"
              mt="20px"
            >
              <Box
                className="glass"
                borderRadius="5px"
                backdropFilter={"blur(5px)"}
                backgroundColor="rgba(37, 38, 42, 0.44)"
                p="15px"
              >
                <Box
                  display={"flex"}
                  className="skills-card-img"
                  justifyContent="center"
                  fontSize={"80px"}
                >
                  {i.icon}
                </Box>
                <Text mt="10px" className="skills-card-name">
                  {i.label}
                </Text>
              </Box>
            </Box>
          );
        })}
      </Box>
      <Box h="100px"></Box>
      <Heading
        w={{ base: "70%", "2xl": "15%" }}
        p="10px"
        m="auto"
        borderBottom={"5px solid white"}
      >
        Tools
      </Heading>
      <Box
        display={"grid"}
        gridTemplateColumns={{
          base: "repeat(1,1fr)",
          sm: "repeat(1,1fr)",
          lg: "repeat(2,1fr)",
          xl: "repeat(4,1fr)",
        }}
        gap="40px"
        justifyContent="space-between"
        w="80%"
        m="auto"
        mt="100px"
      >
        {tools.map((i) => {
          return (
            <Box
              key={i.label}
              cursor={"pointer"}
              boxShadow="rgba(89, 4, 168, 0.137) 4px 5px 4px 3px !important"
              p="20px"
              border={"1.7px solid rgba(200, 137, 230, 0.635)"}
              borderRadius="6px"
              mt="20px"
            >
              <Box
                className="glass"
                borderRadius="5px"
                backgroundColor="rgba(37, 38, 42, 0.44)"
                p="15px"
              >
                <Box display={"flex"} justifyContent="center" fontSize={"80px"}>
                  {i.icon}
                </Box>
                <Text mt="15px">{i.label}</Text>
              </Box>
            </Box>
          );
        })}
      </Box>
      <Box h="100px"></Box>
      <Heading
        w={{ base: "70%", "2xl": "15%" }}
        p="10px"
        m="auto"
        borderBottom={"5px solid white"}
      >
        Git Status
      </Heading>
      <Box
        display={"block"}
        w="80%"
        m="auto"
        mt="50px"
        justifyContent={"center"}
      >
        <Box display={"flex"} justifyContent="space-between" mt="80px">
          <Image
            w="30%"
            id="github-stats-card"
            src="https://github-readme-stats.vercel.app/api?username=YashSharma7746&theme=react&border_radius=4.6&show_icons=true&count_private=true&hide_border=true&show_icons=true&bg_color=153d82&title_color=ffffff&text_color=fff"
          />
          <Image
            w="34%"
            id="github-streak-stats"
            src="https://github-readme-streak-stats.herokuapp.com?user=YashSharma7746&theme=react&hide_border=true&border_radius=4.6&background=#14082b&color=ffffff&text_color=fff"
          />
          <Image
            w="29%"
            id="github-top-langs"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=YashSharma7746&theme=transparent&border_radius=4.6&hide_border=true&layout=compact&show_icons=true&bg_color=153d82&title_color=ffffff&text_color=fff"
          />
        </Box>
        <Box display={"flex"} justifyContent={"center"} mt="80px">
          <GitHubCalender
            username="YashSharma7746"
            blockSize={15}
            blockMargin={5}
            color="#c084f5"
            fontSize={16}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Skills;
